import DimensionList from './DimensionList';

export default DimensionList;
